import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

/**
 * The Quickstart explainer.
 *
 * Lifted out of `nav.js` so two surfaces can open it. The console no longer
 * renders the global header — it carries its own utilities in the top bar — but
 * `/app/map` and `/app/contaminants` still do, so the dialog cannot live inside
 * either one of them.
 *
 * Copy is unchanged from the version that lived in the nav, deliberately: it
 * says what the product does and does not know, and rewording that in passing
 * while moving a file is how such wording quietly drifts.
 */
const QuickstartDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Quickstart Guide</DialogTitle>
        <DialogDescription className="mt-2">
          <p className="mb-4 text-sm font-light">
            Type in the address you want to learn more about. We will cross-reference
            data about contamination from various sources, including LLM-scanned
            documents from government testing, and layer our algorithms on top to infer
            the risk that existing test sites pose to your property.
          </p>
          <p className="mb-4 text-sm font-light">
            In the event we do not have data about your inquiry, we will suggest testing
            and incorporate that feedback back into our results if you provide it to us.
            Note that a lack of testing data does not imply a lack of contamination, just
            that we do not have data to describe the location.
          </p>
          <p className="text-sm font-light">
            If we are sure that the site has been tested and is uncontaminated, we will
            let you know.
          </p>
        </DialogDescription>
      </DialogHeader>
    </DialogContent>
  </Dialog>
);

export default QuickstartDialog;
